import { configureStore } from "@reduxjs/toolkit";
import  addIds  from "./slices/reportsSlice";
export const store=configureStore({
    reducer:{
        addIds
    }
})